import { render, staticRenderFns } from "./userfeedback.vue?vue&type=template&id=1d6a984a"
import script from "./userfeedback.vue?vue&type=script&lang=js"
export * from "./userfeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports